import React, { useCallback, useEffect, useState } from "react";
import { useApi } from "../../hooks/api";
import { useGlobal } from "../../hooks/global";
import { franchiseProps } from "../../interfaces";
import { ProfileForm } from "./ProfileForm";
import { DashboardPage } from "../../components/DashboardPage";
import { ContentOrLoading } from "../../components/Loadings/ContentOrLoading";
import { businessDefaultForm, mapDefaultForm, ProfileDefaultForm } from "../../utils/defaultFormsUtils";
import { positionTypeOptions } from "../../utils/options";

export const Profile: React.FC = () => {
    const { api, user } = useApi()
    const { notify, theme } = useGlobal()

    const [loading, setLoading] = useState(false)
    const [defaultData, setDefaultData] = useState<any>(null)

    const search = useCallback(async () => {
        setLoading(true)

        try {
            const { data } = await api.get(`/users/${user.id}`)

            let _data: any = mapDefaultForm({ data, fields: ProfileDefaultForm })

            _data = {
                id: data.id,
                ..._data,
                position: {
                    label: positionTypeOptions.find((option) => option.value === _data?.position)?.label,
                    value: _data?.position,
                },
            }

            setDefaultData({ ..._data })
        } catch (err) {

            notify("Erro ao Buscar Dados do Perfil!", "error")
        }

        setLoading(false)
    }, [api])

    useEffect(() => { search() }, [])

    return (
        <DashboardPage>
            <ContentOrLoading
                theme={theme}
                loading={loading}
                text={"Buscando Dados do Perfil"}
                children={(
                    <ProfileForm
                        defaultData={defaultData}
                    />
                )}
            />
        </DashboardPage>
    )
}